import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { trackEvent } from '../utils/analytics';

const WHATSAPP_LINK = "https://wa.me/393921037894?text=Ciao%2C%20vorrei%20un%20preventivo%20gratuito%20per%20uno%20sgombero.%20Posso%20inviarvi%20le%20foto%3F";

export default function MobileStickyBar() {
  return (
    <div className="md:hidden fixed bottom-0 left-0 w-full bg-[#050505] border-t border-white/10 p-3 z-[100] flex gap-3 shadow-[0_-10px_30px_rgba(0,0,0,0.8)] pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
      <a 
        href={WHATSAPP_LINK} 
        target="_blank" 
        rel="noreferrer"
        onClick={() => trackEvent('whatsapp_click', 'barra_sticky')}
        className="flex-1 bg-maaich-lime text-black font-display uppercase italic py-3 rounded-md flex items-center justify-center gap-2 text-lg active:scale-95 transition-transform"
      >
        <SafeIcon icon={FiIcons.FiMessageCircle} className="text-xl" />
        WhatsApp
      </a>
      <a 
        href="tel:+393516488306"
        onClick={() => trackEvent('phone_click', 'barra_sticky')}
        className="w-14 bg-white/10 border border-white/20 text-white flex items-center justify-center rounded-md active:scale-95 transition-transform"
        aria-label="Chiama ora"
      >
        <SafeIcon icon={FiIcons.FiPhone} className="text-xl" />
      </a>
    </div>
  );
}